<div class="d-flex justify-content-between">
  <div>
    <button class="back-button btn-primary d-flex align-items-center" alt="Back" (click)="handleBackClick()">
      <i class="material-symbols-outlined mr-2">arrow_back</i>
      <span>Close</span>
    </button>
  </div>
  <div *ngIf="showDeleteButton" class="justify-content-end">
    <button mat-icon-button class="action-icon-button mr-2" matTooltip="Delete" matTooltipPosition="above" matTooltipClass="custom-tooltip"
      type="button" (click)="openDeleteModal()">
      <img src="../../assets/images/neveda-images/delete-icon.svg"
        alt="" class="filter-icon" aria-hidden="true" />
    </button>
    <button class="inbox-btn" aria-label="Open Message Inbox" (click)="navigateToMessageInbox()" type="button">
      Message Inbox
    </button>
  </div>
</div>

<div *ngIf="showDeleteModal" class="delete-modal" id="dashboard_delete_modal">
  <div class="modal-content">
    <div class="modal-header">      
      <h6 class="w-100 text-start font-weight-bold mb-0">Delete Application</h6>
      <div>
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeDeleteModal()"
            (keypress)="closeDeleteModal()" alt="close_icon" tabindex="0">
      </div>
    </div>
    <div class="modal-body mb-2 pb-0">
      <div class="font-14">Are you sure you want to delete this application? This action cannot be undone.</div>
    </div>
    <div class="modal-footer">
      <div class="flex-fill">
        <button class="btn w-50 btn-outline" (click)="closeDeleteModal()">Cancel</button>
        <button class="btn w-50 btn-danger btn-radius" (click)="deleteApplication()">Delete</button>
      </div>
    </div>
  </div>
</div>

















